import { retrieveSovAnalytics } from "components/inputs/SOV/utils/sovDataPersistence";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as analyticsStore from "store/analytics";

/**
 * When persisted analytics only include `sovAnalyticsFileId`, loads SOV / sovCat
 * JSON via `retrieveSovAnalytics` (sovDataPersistence) and merges into Redux.
 *
 * @returns {object | undefined} Resolved program pricing slice for the configured pricing method (from static `sov` config).
 */
export function useSovAnalytics() {
  const dispatch = useDispatch();
  const { data: sovConfig } = staticDataService.useConfigQuery("sov");
  const pricingMethod = sovConfig?.pricingMethod ?? "programPricing";
  const programPricing = useSelector(
    (state) => analyticsStore.select(state)?.[pricingMethod]
  );

  useEffect(() => {
    const fileId = programPricing?.values?.sovAnalyticsFileId;
    if (fileId && !programPricing?.values?.sov) {
      retrieveSovAnalytics(fileId).then((data) => {
        dispatch(
          analyticsStore.update({
            [pricingMethod]: {
              ...programPricing,
              values: {
                ...programPricing.values,
                sov: data.sov,
                sovCat: data.sovCat,
              },
            },
          })
        );
      });
    }
  }, [programPricing, dispatch, pricingMethod]);

  return programPricing;
}
